/* Impression SCDM — LES DIMENSIONS QUE LES NORMES DEMANDENT.

   POURQUOI. Une plaque de matieres dangereuses, une etiquette SIMDUT et un
   panneau routier ne sont pas des autocollants ordinaires : leur dimension
   fait partie de la conformite. Un client qui commande une plaque TMD en 6 po
   se fait refuser son chargement, et c est nous qui l aurons imprimee.

   CE QUE FAIT CE FICHIER, EN TROIS TEMPS.
   1. Quand le client choisit un modele normalise, le configurateur SE MET
      TOUT SEUL a la bonne dimension. Il n a rien a chercher.
   2. S il la change quand meme, un message apparait sous le format et dit ce
      que la norme demande. Il n est jamais bloque : il peut vouloir un
      autocollant de formation, un aimant de bureau, une decoration.
   3. Sur un panneau routier, il ajoute le reste : le vinyle reflechissant
      (le seul qui a du sens dehors), et la quantite 1 dans les choix
      rapides — une municipalite qui remplace un panneau en prend un, pas cent.

   CE QU ON PEUT AFFIRMER, ET CE QU ON NE PEUT PAS. C est la partie la plus
   importante du fichier, et elle a coute une matinee de verification.

   - TMD : le Reglement sur le transport des marchandises dangereuses
     (DORS/2001-286, partie 4) donne des chiffres precis. On les cite comme
     des EXIGENCES, parce que c en sont.
   - SIMDUT : le Reglement sur les produits dangereux N IMPOSE AUCUNE
     DIMENSION. Il exige que l etiquette soit lisible a l oeil nu, point.
     Tout ce qu on peut faire, c est RECOMMANDER une grandeur. Dire au client
     que « la norme exige 4 po » serait faux.
   - MTQ : le Tome V prescrit une dimension par panneau ET par classe de
     route. On a longtemps pose une regle de famille — 600 mm partout sauf les
     travaux — faute d avoir les chiffres. On les a maintenant : les 534 devis
     du Repertoire des dispositifs de signalisation routiere ont ete depouilles
     un a un, et chaque panneau porte SA dimension et la liste de SES grandeurs
     autorisees (voir scdm-mtq-v2.js dans Contenu > Fichiers). La regle de
     famille etait fausse une fois sur deux : le D-100-10-G fait 750 mm, pas
     600. Ce fichier ne devine plus rien, il lit le devis.

   CE QU ON NE DIT PLUS (9 septembre 2026). Le ministere des Transports
   n homologue AUCUN panneau, aucune pellicule, aucun aluminium, aucune encre :
   ses programmes d homologation portent sur les poteaux qui cedent a l impact,
   les extremites de glissieres et le marquage routier. Ce qui existe, c est le
   DEVIS : le Repertoire donne la dimension et le type de pellicule prescrit
   (ASTM D4956), et le donneur d ouvrage exige que la piece livree y reponde —
   les exigences varient d un donneur d ouvrage a l autre. La note ne dit donc
   plus « conforme », « homologue » ni « normalise » a propos de notre piece.
   Elle dit trois choses et se tait : la dimension vient du devis, on ne
   certifie pas la piece finie, et un client qui a un devis en main passe par
   la soumission.

   Rien ici ne touche au prix ni au fichier envoye : c est de la mise en place
   et de l avertissement.
*/

(function () {
  'use strict';

  var PO = 25.4;
  function pouces(mm) { return Math.round(mm / PO * 100) / 100; }

  /* =====================================================================
     LA TABLE DES NORMES
     Premiere regle qui correspond a l identifiant du modele. L ordre compte :
     les cas particuliers sont AVANT les regles generales.

     taille : 'custom' + larg/haut en pouces, ou l identifiant d un format
              de la liste (voir TAILLES dans scdm-data.js)
     fam    : 'tmd' | 'mtq' | 'simdut' -> quel bloc de FAMILLES on ajoute
     libre  : true -> aucune dimension imposee : on pose une valeur par
              defaut, mais on n avertit jamais si le client la change
     ===================================================================== */

  var REGLES = [

    /* ---- Transport de marchandises dangereuses (TMD) ------------------
       Reglement sur le transport des marchandises dangereuses,
       DORS/2001-286, partie 4. */

    { test: /^tmd-panneau-un-/, exige: true,
      taille: 'custom', larg: pouces(300), haut: pouces(120),
      fam: 'tmd', piece: 'panneau',
      quoi: 'Le panneau orange du numéro UN',
      dit: 'doit mesurer 300 mm sur 120 mm selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    { test: /^tmd-marque-un3373/, exige: true, taille: '2', fam: 'tmd', piece: 'marque',
      quoi: 'La marque UN3373',
      dit: 'doit mesurer au moins 50 mm de côté selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    { test: /^tmd-marque-(quantite-limitee|quantites-exceptees)/, exige: true, taille: '4', fam: 'tmd', piece: 'marque',
      quoi: 'La marque de quantité limitée',
      dit: 'doit mesurer au moins 100 mm sur 100 mm selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    { test: /^tmd-marque-(polluant-marin|temperature-elevee)/, exige: true, taille: '10', fam: 'tmd', piece: 'marque',
      quoi: 'Cette marque',
      dit: 'doit mesurer au moins 250 mm de côté sur un grand contenant selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    /* Les etiquettes de petit contenant : classe 6.2 avec mention CANUTEC,
       fissile et les trois categories radioactives. */
    { test: /^tmd-(6-2-matieres-infectieuses-etiquette|7-)/, exige: true, taille: '4', fam: 'tmd', piece: 'étiquette',
      quoi: 'Une étiquette apposée sur un petit contenant',
      dit: 'doit mesurer au moins 100 mm sur 100 mm selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    /* Les autres marques n ont pas de dimension dans le reglement canadien :
       elles renvoient a des normes internationales (ISO 780 pour les fleches
       d orientation, par exemple). On ne cite donc aucun chiffre. */
    { test: /^tmd-marque-/, exige: false, taille: null, fam: 'tmd', piece: 'marque',
      quoi: 'Cette marque',
      dit: 'n’a pas de dimension imposée par le règlement fédéral sur le transport des marchandises dangereuses : elle doit seulement rester bien visible sur le colis' },

    /* Tout le reste du catalogue TMD : les losanges de grand contenant. */
    { test: /^tmd-/, exige: true, taille: '14', fam: 'tmd',
      quoi: 'Une plaque apposée sur un grand contenant',
      dit: 'doit mesurer au moins 250 mm de côté selon le règlement fédéral sur le transport des marchandises dangereuses (DORS/2001-286)' },

    /* ---- Signalisation routiere du Quebec -----------------------------
       UNE SEULE regle ici, et elle ne porte aucun chiffre : les dimensions
       arrivent du devis du Ministere, panneau par panneau, par la cle « mtq »
       du modele (voir regleRoutiere plus bas). Un panneau routier qu on ne
       connaitrait pas — un modele ajoute a la main, par exemple — tombe sur
       cette regle-ci et n a droit qu au rappel general : pas de chiffre
       invente. */
    { test: /^mtq-/, mtqPourAvoir: true, exige: false, taille: null, fam: 'mtq',
      quoi: 'Ce panneau',
      dit: 'a une dimension et un dessin prescrits au Répertoire de signalisation routière selon la classe de route — c’est le devis qui tranche',
      routier: true },

    /* ---- SIMDUT --------------------------------------------------------
       AUCUNE dimension imposee. On recommande, et on le dit. */
    { test: /^simdut-/, exige: false, taille: '4', fam: 'simdut', libre: true,
      quoi: 'Le SIMDUT',
      dit: 'n’impose aucune dimension : le pictogramme doit seulement rester bien visible et lisible à l’œil nu. On met 4 po par défaut — 2 po sur un bidon, 6 po et plus pour une aire d’entreposage' }
  ];

  var LIEN_RSR = 'https://www.rsr.transports.gouv.qc.ca/dispositifs/panneaux.aspx';
  var LIEN_SOUM = '/pages/soumission';

  /* CE QU ON AJOUTE APRES LA DIMENSION, PAR FAMILLE.
     Deux phrases au plus : ce qu on fait et ce qu on ne certifie pas, puis ce
     qui reste du cote du client. Le renvoi vers la soumission est ajoute
     ensuite pour tout le monde. */
  var FAMILLES = {
    mtq: {
      piece: 'panneau',
      certif: 'On imprime sur un vinyle réfléchissant de qualité équivalente, ' +
              'mais pas sur une pellicule achetée sous un type précis : ' +
              'nous ne certifions pas la pièce finie.',
      charge: 'La classe de pellicule, le support, la hauteur de pose et ' +
              'l’emplacement sont exigés par le donneur d’ouvrage et restent de votre côté.'
    },
    tmd: {
      piece: 'plaque',
      certif: 'On reproduit le dessin du règlement, ' +
              'mais nous ne certifions pas la pièce finie.',
      charge: 'Le support, la pose et la durabilité exigés pour votre expédition ' +
              'restent de votre côté.'
    },
    simdut: {
      piece: 'étiquette',
      certif: 'On reproduit le pictogramme, mais nous ne certifions ni la pièce ' +
              'finie ni votre étiquetage.',
      charge: ''
    }
  };

  /* =====================================================================
     ETAT
     ===================================================================== */

  var modele = null;      /* le modele choisi */
  var regle = null;       /* la regle qui s y applique */
  var posee = false;      /* la dimension normalisee a-t-elle ete posee ? */
  var qteOrig = null;     /* les quantites rapides d origine */
  var reflPose = false;   /* c est NOUS qui avons mis le reflechissant ? */
  var unitePosee = false; /* c est NOUS qui avons bascule les cotes en mm ? */
  var avis = null, avisDevis = null;

  function $(s) { return document.querySelector(s); }
  function D() { return window.SCDM_DATA; }
  function S() { return window.SCDM; }

  function trouverRegle(id) {
    for (var i = 0; i < REGLES.length; i++) {
      if (REGLES[i].test.test(id)) return REGLES[i];
    }
    return null;
  }

  /* LA REGLE D UN PANNEAU ROUTIER, TIREE DE SON DEVIS.

     scdm-mtq-v2.js attache a chaque panneau un objet « mtq » :
       { mm: [[750,750],[900,900],[1200,1200]], pel: 'jaune, type I' }
     La premiere grandeur est celle du devis — c est elle qu on pose. Les
     suivantes sont autorisees par le Tome V selon la classe de route et la
     vitesse affichee : le client peut les prendre SANS etre averti, c est
     pour ca qu on les garde dans « autres ». */
  function grandeur(g) { return g[0] + ' × ' + g[1] + ' mm'; }

  function regleRoutiere(m) {
    var d = m && m.mtq;
    if (!d || !d.mm || !d.mm.length) return null;
    var def = d.mm[0];

    var dit = 'donne ce panneau en <b>' + grandeur(def) + '</b>';
    if (d.mm.length > 1) {
      dit += ' (aussi ' + d.mm.slice(1).map(grandeur).join(', ') +
             ' selon la classe de route)';
    }
    dit += ' — c’est le dessin et la grandeur que nous reproduisons';

    return {
      exige: true,
      taille: 'custom',
      fam: 'mtq',
      larg: pouces(def[0]), haut: pouces(def[1]),
      autres: d.mm,
      pel: d.pel,
      quoi: '<a href="' + LIEN_RSR + '" target="_blank" rel="noopener">Le Répertoire ' +
            'de signalisation routière</a>',
      dit: dit,
      routier: true
    };
  }

  /* =====================================================================
     POSER LA DIMENSION
     On passe par les memes evenements que le client : scdm.js n expose pas
     de fonction pour changer l etat, mais il ecoute son menu et ses deux
     champs. On les actionne, il fait le reste.
     ===================================================================== */

  function poserTaille(r) {
    var sel = $('#scdmTaille');
    if (!sel) return false;

    if (r.taille === 'custom') {
      var L = $('#scdmLargeur'), H = $('#scdmHauteur');
      if (!L || !H) return false;
      sel.value = 'custom';
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      L.value = r.larg; L.dispatchEvent(new Event('input', { bubbles: true }));
      H.value = r.haut; H.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    }

    if (!r.taille) return false;
    if (!sel.querySelector('option[value="' + r.taille + '"]')) return false;
    sel.value = r.taille;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  /* La dimension courante est-elle celle du devis ? On compare en millimetres
     arrondis : le client peut avoir tape 23,6 au lieu de 23,62. Une famille
     « libre » (le SIMDUT) n a aucune dimension imposee : jamais d avertissement. */
  function bonneDimension(r) {
    var e = S() && S().etat;
    if (!e || !r || !r.taille || r.libre) return true;

    function mm(po) { return Math.round(po * PO); }

    if (r.taille === 'custom') {
      if (e.taille !== 'custom') return false;
      var L = mm(Number(e.larg) || 0), H = mm(Number(e.haut) || 0);

      /* Un panneau routier a PLUSIEURS grandeurs officielles. Le client qui
         monte de 600 a 750 mm parce que sa route est plus rapide fait
         exactement ce que le Tome V demande : on ne l avertit pas. */
      if (r.autres) {
        return r.autres.some(function (g) {
          return Math.abs(L - g[0]) <= 3 && Math.abs(H - g[1]) <= 3;
        });
      }
      return Math.abs(L - mm(r.larg)) <= 3 && Math.abs(H - mm(r.haut)) <= 3;
    }
    return e.taille === r.taille;
  }

  /* La grandeur que le client a sous les yeux, en millimetres, quand elle fait
     partie des grandeurs officielles du panneau. */
  function choisie(r) {
    var e = S() && S().etat;
    if (!e || e.taille !== 'custom') return libelle(r);
    return Math.round((Number(e.larg) || 0) * PO) + ' × ' +
           Math.round((Number(e.haut) || 0) * PO) + ' mm';
  }

  function libelle(r) {
    if (r.taille === 'custom') {
      return Math.round(r.larg * PO) + ' × ' + Math.round(r.haut * PO) + ' mm';
    }
    var t = (D().TAILLES || []).filter(function (x) { return x.id === r.taille; })[0];
    return t ? (t.label + ' — ' + t.mm) : r.taille;
  }

  /* =====================================================================
     LE MESSAGE
     ===================================================================== */

  var STYLE = 'margin:10px 0 0;padding:11px 13px;border-radius:8px;font-size:13px;line-height:1.5;';
  var INFO   = 'background:#EAF3FF;border:1px solid #B7D4F5;color:#173F68;';
  var ALERTE = 'background:#FFF4E8;border:1px solid #F0CE9E;color:#7A4408;';

  function boite() {
    if (avis) return avis;
    var sel = $('#scdmTaille');
    if (!sel) return null;
    avis = document.createElement('p');
    avis.id = 'scdmNormeAvis';
    avis.hidden = true;
    var champ = sel.closest ? sel.closest('.fld') : sel.parentElement;
    (champ || sel).insertAdjacentElement('afterend', avis);
    return avis;
  }

  /* LA PREMIERE PHRASE : d ou vient la dimension. */
  function phraseDimension(r) {
    if (!r.taille || r.libre || r.autres || r.taille === 'custom') {
      return '<b>' + r.quoi + '</b> ' + r.dit + '.';
    }
    return '<b>' + r.quoi + '</b> ' + r.dit + ', soit <b>' + libelle(r) + '</b>.';
  }

  /* LA DERNIERE PHRASE : celle qui compte. Un client qui a un devis en main
     doit avoir envie de cliquer — c est une aide, pas un refus. */
  function phraseSoumission(f, r) {
    return 'Votre ' + ((r && r.piece) || f.piece) + ' doit répondre à un devis ? ' +
           '<a href="' + LIEN_SOUM + '">Passez par la demande de soumission</a> — ' +
           'on regarde votre devis avec vous.';
  }

  function rafraichir() {
    var b = boite();
    if (!b) return;

    if (!modele || !regle) { b.hidden = true; return; }

    var r = regle;
    var f = FAMILLES[r.fam] || FAMILLES.mtq;
    var ok = bonneDimension(r);
    b.hidden = false;
    b.setAttribute('style', STYLE + (ok ? INFO : ALERTE));

    var t = [];

    if (ok) {
      t.push(phraseDimension(r));
      t.push(f.certif);
      /* La pellicule que le devis prescrit remplace la phrase generique :
         c est la meme idee, avec le chiffre en plus. Une phrase, pas deux. */
      if (r.pel) {
        t.push('Le devis prescrit ici une pellicule <b>' + r.pel + '</b> ; cette ' +
               'classe, le support, la hauteur de pose et l’emplacement sont exigés ' +
               'par le donneur d’ouvrage et restent de votre côté.');
      } else if (f.charge) {
        t.push(f.charge);
      }
    } else {
      /* Le client a change la grandeur. On le laisse faire — il peut vouloir un
         autocollant de formation ou une decoration — mais on coupe court : une
         phrase de rappel, une phrase de renvoi. */
      t.push('<b>Attention à la grandeur.</b> ' + phraseDimension(r) +
             ' Vous avez choisi autre chose : c’est permis, mais la pièce ' +
             'ne répondra plus au devis.');
      t.push(f.certif);
    }

    t.push(phraseSoumission(f, r));

    b.innerHTML = t.join(' ');
  }

  /* =====================================================================
     LES PANNEAUX ROUTIERS : reflechissant, quantite 1, cotes en mm
     ===================================================================== */

  function reglagesRoutiers(actif) {
    var d = D();
    if (!d) return;

    if (qteOrig === null) qteOrig = d.QTE_RAPIDES.slice();

    var voulu = actif ? [1, 2, 5, 10, 25, 50] : qteOrig;
    var change = voulu.length !== d.QTE_RAPIDES.length ||
                 voulu.some(function (q, i) { return q !== d.QTE_RAPIDES[i]; });
    if (change) {
      d.QTE_RAPIDES.length = 0;
      voulu.forEach(function (q) { d.QTE_RAPIDES.push(q); });
      /* Une municipalite qui remplace UN panneau ne doit pas tomber sur une
         quantite de 100 heritee de la visite precedente. */
      if (actif && Number(S().etat.qte) > 10) S().etat.qte = 1;
    }

    /* UN PANNEAU ROUTIER SE LIT EN MILLIMETRES. Le Tome V, le devis et
       l inspecteur municipal parlent tous en mm ; « 29,53 po » ne veut rien
       dire pour eux. On bascule donc l affichage des cotes en mm a l entree,
       et on remet le pouce en sortant — mais seulement si c est nous qui
       avions bascule, jamais si c est le client. */
    var voulue = actif ? 'mm' : 'po';
    if (actif ? !unitePosee : unitePosee) {
      var bu = document.querySelector('[data-champ="unite"][data-val="' + voulue + '"]');
      if (bu && S().etat.unite !== voulue) { bu.click(); unitePosee = actif; }
      else if (!actif) { unitePosee = false; }
    }

    if (actif) {
      var m = (d.MATIERES || []).filter(function (x) { return x.id === 'reflechissant'; })[0];
      if (m && m.stock !== false && S().etat.matiere !== 'reflechissant') {
        S().etat.matiere = 'reflechissant';
        reflPose = true;
        change = true;
      }
    } else if (reflPose && S().etat.matiere === 'reflechissant') {
      /* On quitte la signalisation routiere. Le reflechissant etait NOTRE
         choix, pas celui du client : on le retire, sinon il se retrouve avec
         un pictogramme SIMDUT sur du film de panneau de route, sans prix et
         renvoye vers la soumission sans comprendre pourquoi. Si c est LUI qui
         l avait choisi, reflPose est faux et on n y touche pas. */
      S().etat.matiere = (d.DEFAUTS && d.DEFAUTS.matiere) || 'blanc-mat';
      reflPose = false;
      change = true;
    }
    return change;
  }

  /* =====================================================================
     LA MATIERE SUR DEVIS
     Le reflechissant est en inventaire mais son prix n est pas fixe. On
     laisse le client le choisir et tout configurer — il verra sa piece a
     l ecran — mais l ajout au panier part vers la soumission au lieu de
     donner un prix qu on ne peut pas tenir.
     ===================================================================== */

  function matiereDevis() {
    var d = D(), e = S() && S().etat;
    if (!d || !e) return null;
    var m = (d.MATIERES || []).filter(function (x) { return x.id === e.matiere; })[0];
    return (m && m.devis) ? m : null;
  }

  function boiteDevis() {
    if (avisDevis) return avisDevis;
    var bouton = $('#scdmAjouter');
    if (!bouton || !bouton.parentElement) return null;
    avisDevis = document.createElement('p');
    avisDevis.id = 'scdmDevisAvis';
    avisDevis.hidden = true;
    avisDevis.setAttribute('style', STYLE + INFO);
    bouton.parentElement.insertBefore(avisDevis, bouton);
    return avisDevis;
  }

  function rafraichirDevis() {
    var b = boiteDevis();
    if (!b) return;
    var m = matiereDevis();
    if (!m) { b.hidden = true; return; }
    b.hidden = false;
    b.innerHTML = '<b>' + m.label + ' — sur devis.</b> Ce film coûte jusqu’à seize fois ' +
      'le vinyle ordinaire et son prix dépend de la série et du format du rouleau : ' +
      'on ne veut pas vous annoncer un prix qu’on ne pourrait pas tenir. ' +
      'Finissez votre configuration, puis <a href="/pages/soumission">demandez la soumission</a> — ' +
      'on vous revient avec le prix exact.';
  }

  /* On coupe l ajout au panier AVANT scdm.js (phase de capture) : sans prix
     ferme, cette ligne n a rien a faire dans le panier. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#scdmAjouter') : null;
    if (!b || !matiereDevis()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/pages/soumission';
  }, true);

  /* =====================================================================
     LE FIL : quel modele est choisi ?
     scdm.js ne garde pas l identifiant du modele dans son etat, seulement
     l image. On ecoute donc le clic sur la tuile, comme le fait deja
     scdm-tmd-format.js.
     ===================================================================== */

  document.addEventListener('click', function (e) {
    var t = (e.target && e.target.closest) ? e.target.closest('[data-modele]') : null;
    if (!t) return;
    var id = t.getAttribute('data-modele');
    var M = window.SCDM_MODELES;
    modele = (M && M.LISTE) ? M.LISTE.filter(function (m) { return m.id === id; })[0] : null;
    regle = modele ? trouverRegle(modele.id) : null;
    if (regle && regle.mtqPourAvoir) regle = regleRoutiere(modele) || regle;
    posee = false;

    setTimeout(function () {
      var routier = !!(regle && regle.routier);
      reglagesRoutiers(routier);
      if (regle && regle.taille && !posee) posee = poserTaille(regle);
      rafraichir();
      rafraichirDevis();
    }, 120);
  }, true);

  /* Le client change quelque chose : on refait le point. */
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.id === 'scdmTaille')) setTimeout(both, 0);
  });
  document.addEventListener('input', function (e) {
    if (e.target && (e.target.id === 'scdmLargeur' || e.target.id === 'scdmHauteur')) {
      setTimeout(rafraichir, 0);
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-champ="matiere"]') : null;
    if (b) { reflPose = false; setTimeout(rafraichirDevis, 60); }
  });

  function both() { rafraichir(); rafraichirDevis(); }

  /* =====================================================================
     DEMARRAGE
     ===================================================================== */

  function demarrer() {
    boite();
    boiteDevis();
    both();

    /* scdm-tmd-format.js a ete retire de sections/scdm-catalogue.liquid le
       5 septembre 2026 : son avis disait la meme chose que celui-ci, et son
       ajout du format 14 po est passe dans scdm-data.js. Le filet reste, au
       cas ou le fichier serait rappele quelque part : il ne coute rien et
       evite deux messages identiques l un sous l autre. */
    setInterval(function () {
      var vieux = document.getElementById('scdmTmdAvis');
      if (vieux && !vieux.hidden) vieux.hidden = true;
    }, 400);
  }

  function quandPret(n) {
    if (document.getElementById('scdmTaille') && window.SCDM && window.SCDM_DATA) return demarrer();
    if ((n || 0) > 80) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();